import React from 'react';
import BrandingFooter from '../common/BrandingFooter';
import MatchWidgetShell from '../common/MatchWidgetShell';
import MatchScoreHero from '../common/MatchScoreHero';
import MatchGoalsSection from '../common/MatchGoalsSection';

export default function GoalsList({
  showBranding = false,
  competitionLabel = 'Premier League',
  featuredMatch = null,
  goals = [],
}) {
  const m = featuredMatch || {};
  const list = goals.length ? goals : (m.goals || []).filter((g) => g.type === 'goal' || !g.type);

  return (
    <div>
      <MatchWidgetShell competitionLabel={competitionLabel} subtitle="Goal scorers">
        <MatchScoreHero match={m} compact />
        {list.length ? (
          <MatchGoalsSection match={m} goals={list} title="All goals" maxPerTeam={20} />
        ) : (
          <p className="text-center text-xs py-10 px-4" style={{ color: 'var(--sw-muted)' }}>
            No goals recorded for this match yet.
          </p>
        )}
      </MatchWidgetShell>
      {showBranding && <BrandingFooter />}
    </div>
  );
}
